import React from "react";

/**
 * GMA-1149 — Pontosense Care Web admin launcher.
 *
 * Tenant-admin-only escape hatch that opens `pc.pontosense.com/#/admin`
 * in a new tab. Admins use it to create caregivers and bind them to
 * Homes inside the partner UI; the GMA-1150 matrix UI then tracks what
 * they did locally via the caregiver_pontosense_access table (GMA-1151).
 *
 * The button intentionally has zero coupling to the BE — it is a pure
 * link. We export the URL as a constant so the matrix UI (and tests)
 * can reuse it without re-declaring the magic string.
 */

export const PONTOSENSE_ADMIN_URL = "https://pc.pontosense.com/#/admin";

const isTenantAdmin = (currentUser) =>
  Boolean(currentUser?.isSuperAdmin || currentUser?.isAdmin);

const PontosenseAdminLauncher = ({ currentUser, style }) => {
  if (!isTenantAdmin(currentUser)) return null;

  const handleClick = (ev) => {
    ev?.preventDefault?.();
    window.open(PONTOSENSE_ADMIN_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="btn-primary-lg"
      title="Open Pontosense Care Web admin"
      style={{
        marginRight: "10px",
        ...style,
      }}
    >
      Pontosense admin
    </button>
  );
};

export default PontosenseAdminLauncher;
